import React from 'react';
import ComingSoon from './ComingSoon';

const MyTrip = () => {
  return <ComingSoon title="My Trip" />;
};

export default MyTrip;














